import { nearestUsableTick as sdkNearestUsableTick } from "@uniswap/v3-sdk"

import { MAX_TICK, MIN_TICK } from "./tick-math"

export function nearestUsableTick(tick: number, spacing: number): number {
  return sdkNearestUsableTick(tick, spacing)
}

export function fullRangeTicks(spacing: number): { tickLower: number; tickUpper: number } {
  const tickLower = nearestUsableTick(MIN_TICK, spacing)
  const tickUpper = nearestUsableTick(MAX_TICK, spacing)
  return { tickLower, tickUpper }
}

export function alignToSpacing(
  tick: number,
  spacing: number,
  direction: "down" | "up" | "nearest" = "nearest",
): number {
  if (tick < MIN_TICK || tick > MAX_TICK) {
    throw new Error(`tick ${tick} out of range`)
  }
  if (spacing <= 0) {
    throw new Error(`invalid spacing ${spacing}`)
  }
  const rounded = Math.round(tick / spacing) * spacing
  if (direction === "nearest") return rounded
  if (direction === "down") {
    return rounded > tick ? rounded - spacing : rounded
  }
  return rounded < tick ? rounded + spacing : rounded
}
